"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Link } from "@/components/common/Link";
export default function Hotelpartnerfaq() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const faqs = [{
    question: "How can revenue management improve my hotel's profitability?",
    answer: "Revenue management optimizes your pricing and inventory strategies based on real-time market demand. By leveraging data-driven insights, we help you capture the right guest at the right price, significantly increasing your RevPAR and overall bottom-line performance."
  }, {
    question: "What is included in a comprehensive revenue audit?",
    answer: "Our audit covers a deep dive into your current OTA performance, rate parity status, tech stack efficiency, and competitor benchmarking. We identify missed opportunities and provide a clear, actionable roadmap to reclaim lost revenue and streamline your operations."
  }, {
    question: "Do you assist with OTA listing optimization?",
    answer: "Yes. We specialize in enhancing your presence on major OTAs like Booking.com and Expedia. From content optimization and high-quality imagery strategy to dynamic rate management, we ensure your property stands out to drive higher conversion rates."
  }, {
    question: "How do you approach hospitality tech stack recommendations?",
    answer: "We evaluate your current systems—PMS, Channel Manager, and Booking Engine—to ensure they are integrated and efficient. We recommend scalable, modern solutions that reduce manual workload and improve the guest booking experience."
  }, {
    question: "Is your consulting service suitable for independent hotels?",
    answer: "Absolutely. We work closely with independent hotel owners and boutique properties to level the playing field against larger chains. Our strategies are tailored to your unique property size, location, and target market."
  }, {
    question: "How do we get started with a consultation?",
    answer: "Getting started is simple. You can book a discovery call through our contact page, where we will discuss your current challenges and goals. From there, we will propose a customized strategy to help you maximize your hotel's revenue potential."
  }];
  return <section data-section-id="4475" id="hotelpartnerfaq" className="bg-slate-50 text-slate-900 py-24 md:py-32 px-6 md:px-12 lg:px-20">
      <div ref={ref} className={`max-w-7xl mx-auto transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8">
          {}
          <div className="lg:col-span-4">
            <div className="lg:sticky lg:top-32">
              <p className="font-default text-xs uppercase tracking-widest text-blue-700 mb-8">
                — Expert Insights
              </p>
              <h2 className="font-default text-4xl md:text-5xl lg:text-5xl leading-[1.05] tracking-tight text-slate-900">
                Revenue
                <br />
                <span className="italic text-blue-700">clarified.</span>
              </h2>
            </div>
          </div>

          {}
          <div className="lg:col-span-7 lg:col-start-6">
            <div className="border-t border-slate-200">
              <Accordion type="single" collapsible className="w-full">
                {faqs.map((faq, i) => <AccordionItem key={i} data-index={i} value={`item-${i}`} className="border-b border-slate-200 last:border-b-0 group">
                    <AccordionTrigger className="py-8 hover:no-underline text-left [&>svg]:hidden [&[data-state=open]_.faq-icon]:rotate-45 [&[data-state=open]_.faq-icon]:text-blue-700 [&[data-state=open]_.faq-question]:translate-x-1">
                      <span className="faq-question font-default text-xl md:text-2xl text-slate-900 transition-transform duration-300 ease-out group-hover:translate-x-1 leading-snug pr-6">
                        {faq.question}
                      </span>
                      <span aria-hidden="true" className="faq-icon shrink-0 text-slate-400 transition-all duration-300 ease-out group-hover:text-blue-700 text-2xl font-light leading-none mt-1">
                        +
                      </span>
                    </AccordionTrigger>
                    <AccordionContent className="pb-8 pt-0">
                      <p className="font-default text-base text-slate-600 leading-[1.7] max-w-[600px]">
                        {faq.answer}
                      </p>
                    </AccordionContent>
                  </AccordionItem>)}
              </Accordion>
            </div>

            {}
            <div className="mt-16 pt-8 border-t border-slate-200">
              <p className="font-default text-xs uppercase tracking-widest text-slate-500">
                Need more answers?{" "}
                <span className="mx-2 text-slate-300">→</span>
                <Link to="/ContactPage" className="relative inline-block text-blue-700 hover:text-blue-900 transition-colors duration-300 group/link">
                  Contact Sunil Singh
                  <span className="absolute left-0 -bottom-0.5 h-px w-full bg-current origin-left scale-x-100 transition-transform duration-500 ease-out group-hover/link:scale-x-0" />
                  <span className="absolute left-0 -bottom-0.5 h-px w-full bg-blue-900 origin-right scale-x-0 transition-transform duration-500 ease-out group-hover/link:origin-left group-hover/link:scale-x-100" />
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}